export default "__VITE_ASSET__sEzGEog6__"